import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { environment } from 'src/environments/environment'

export const expertGroupPortalContent: ExpertGroupPortal[] = [
  {
    id: 'ai-futures',
    slug: 'futures',
    breadcrumbSlug: 'futures',
    title: 'AI Futures',
    subtitle:
      'Exploring potential AI futures to help governments actively shape them today.',
    baseUrl: '/site/ai-futures',
    tagSlugs: ['futures'],
    workingGroupSlug: environment.futuresWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  },
  {
    id: 'compute-climate',
    slug: 'compute-climate',
    breadcrumbSlug: 'computeClimate',
    title: 'AI Compute & Climate Change',
    subtitle:
      'Coherent AI-related policymaking will require an understanding of AI computing capacities and their environmental impact, particularly for supercomputing technologies.',
    baseUrl: '/site/compute-climate',
    tagSlugs: ['compute', 'climate'],
    workingGroupSlug: environment.computeClimateWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  },
  {
    id: 'risk-accountability',
    slug: 'risk-accountability',
    breadcrumbSlug: 'riskAccountability',
    title: 'AI Risk & Accountability',
    subtitle:
      'Exploring how to ensure AI systems are accountable to the public.',
    baseUrl: '/site/risk-accountability',
    tagSlugs: ['risk', 'accountability'],
    workingGroupSlug: environment.riskAccountabilityWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  },
  {
    id: 'incidents',
    slug: 'incidents',
    breadcrumbSlug: 'incidents',
    title: 'AI Incidents',
    subtitle:
      'Exploring how to ensure AI systems are accountable to the public.',
    baseUrl: '/site/incidents',
    tagSlugs: ['incidents'],
    workingGroupSlug: environment.incidentsWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  },
  {
    id: 'data-privacy',
    slug: 'data-privacy',
    breadcrumbSlug: 'dataPrivacy',
    title: 'AI, Data & Privacy',
    subtitle:
      'Privacy and data protection laws play a crucial role in building trustworthy AI.',
    baseUrl: '/site/data-privacy',
    tagSlugs: ['data-privacy'],
    workingGroupSlug: environment.dataPrivacyWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  },
  {
    id: 'health',
    slug: 'health',
    breadcrumbSlug: 'health',
    title: 'AI & Health',
    subtitle:
      'AI provides hope for health systems facing multiple crises, but its use in healthcare creates concerns about the privacy of sensitive data and liability from using black box algorithms. The OECD helps governments to develop policies that enable responsible AI in healthcare.',
    baseUrl: '/site/health',
    tagSlugs: ['health'],
    workingGroupSlug: environment.healthWorkingGroupSlug,
    resources: [
      { label: 'Publications', slug: 'publications' },
      { label: 'Meeting summaries', slug: 'meeting-summaries' },
      { label: 'External resources', slug: 'external-resources' }
    ]
  }
]
